import { render, staticRenderFns } from "./ShareDevelopmentDetails.vue?vue&type=template&id=a545d4a0"
import script from "./ShareDevelopmentDetails.vue?vue&type=script&lang=js"
export * from "./ShareDevelopmentDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports